import { ChainName } from './name'

export const EXPLORER = {
  [ChainName.ETHEREUM]: process.env.REACT_APP_ETH_EXPLORER,
  [ChainName.ALGORAND]: process.env.REACT_APP_ALGO_EXPLORER,
  [ChainName.STELLAR]: process.env.REACT_APP_STELLAR_EXPLORER,
  [ChainName.BASE]: process.env.REACT_APP_BASE_EXPLORER
}
